//code by Felix Caraballo polycaravan.com
$(document).ready(function () {

  //Dynamic states of form
  var current_fs, next_fs, previous_fs;
  var animating = $(this).is(":animated");


  //HTML SELECTORS

  //Buttons selectors and classes
  var [active, next, previous, prevNext, reset, submit, dogSelect, condfields,
    condlabels, add
  ] = [(".active"), (".next"), (".previous"), (".prevnext"), (".reset"),
  (".submit"), (".dogselect"), (".condfield"), (".condlabel"), (".add")
    ]
  
  var results = (".result");
  var [req, dogName, dogAge, date, dogFM, spayNeuter, nursing, dogWeight, dogHealth, dogCounter, nursingLabel] = [(".req"), ("#dogName"), ("#dogAge"), ("#date"), ("#dogFM"),
  ("#spayNeuter"), ("#nursing"), ("#dogWeight"), ("#health"), (".dogCounter"), ("#nursingLabel")
  ];

  //Food container infographic sections
  var [ctrB, ctrLM, ctrHM, ctrT] =
  [
    $("#Cup-Bottom").children(),
    $("#Cup-Low-Mid").children(),
    $("#Cup-High-Mid").children(),
    $("#Cup-Top").children()
  ];

  var [btrB, btrLM, btrHM, btrT] =
    [
      $("#Box-Bottom"),
      $("#Box-Low-Mid"),
      $("#Box-High-Mid"),
      $("#Box-Top")
    ];

  //LOCAL STORAGE VARIABLES
  
  //Keep count of customer dogs
  var dogCount = $.parseJSON(localStorage.getItem("dogCount"));
  if (dogCount == null) {
    dogCount = localStorage.setItem("dogCount", JSON.stringify(0));
  } else { }
  $(dogCounter).text(dogCount);

  var finalAmt;
  if (finalAmt < 1 || finalAmt == null) {
    localStorage.setItem("finalAmt", JSON.stringify(0));
  } else { }

  //If stored select option values are still null, make them 0 instead
  if (localStorage.getItem("date") == null) {
    localStorage.setItem("date", "0");
    localStorage.setItem("dogFM", "0");
    localStorage.setItem("spayNeuter", "0");
    localStorage.setItem("nursing", "0");
    localStorage.setItem("dogHealth", "0");
  } else { };

  //Pull required fields last values from local storage
  $(dogName).val(localStorage.getItem("dogName"));
  $(dogAge).val(localStorage.getItem("dogAge"));
  $(dogWeight).val(localStorage.getItem("dogWeight"));
  $(date).prop("selectedIndex", $.parseJSON(localStorage.getItem("date")));
  $(dogHealth).prop("selectedIndex", $.parseJSON(localStorage.getItem("dogHealth")));
  $(dogFM).prop("selectedIndex", $.parseJSON(localStorage.getItem("dogFM")));
  $(spayNeuter).prop("selectedIndex", $.parseJSON(localStorage.getItem("spayNeuter")));
  $(nursing).prop("selectedIndex", $.parseJSON(localStorage.getItem("nursing")));

  //If last dog entered was male, update identity
  var dogsx = $(dogFM).prop("selectedIndex");
  if (dogsx > 0) {
    identity();
  }


  // Functions for buttons Next/Previous
  $(next).click(function () {
    if (animating) { } else {
      animating = true;
      current_fs = $(this).closest("fieldset");
      next_fs = $(this).closest("fieldset").next();
      //activate next step on progressbar using the index of next_fs
      $("fieldset.active").removeClass("active"); // Hide current active form group.
      $("#progressbar li").eq($("fieldset").index(next_fs)).addClass("active").css("cursor", "pointer");
      //hide the current fieldset with style
      current_fs.fadeOut(500).removeClass("active");
      //show the next fieldset
      next_fs.fadeIn(500).addClass("active");
      next_fs.children(condlabels).first().fadeIn(500);
      animating = false;
      $(condfields).each(condFieldFunction);
    }
  });

  $(previous).click(function previous () {
    if (animating) { } else {
      animating = true;
      current_fs = $(this).closest("fieldset");
      previous_fs = $(this).closest("fieldset").prev();
      //hide the current fieldset with style
      current_fs.fadeOut(500).removeClass("active");
      //show the previous fieldset
      previous_fs.fadeIn(500).addClass("active");
      animating = false;
    }
  });

  // Show/Hide functions for the Next buttons
  function showNext() {
    var activeNext = $(active).children(prevNext).children(next);
    $(activeNext).fadeIn(500);
  }

  function hideNext() {
    var activeNext = $(active).children(prevNext).children(next);
    $(activeNext).fadeOut(500);
  }

  //Make multi-step icons clickable and show instructions if greyed out icons are clicked.
  $("#1stli").click(function () { // User clicks info icon from progress bar.
    $("fieldset.active").fadeOut(500).removeClass("active"); // Hide current active form group.
    $("#1stfs").fadeIn(500).addClass("active"); // Reveal 1st form group.
  });

  $("#2ndli").click(function () { // User clicks info icon from progress bar.
    if ($("#2ndli").hasClass("active")) {
      $("fieldset.active").fadeOut(500).removeClass("active"); // Hide current active form group.
      $("#2ndfs").fadeIn(500).addClass("active"); //Reveal 2nd form group.
    } else {
      alert("Please fill previous fields before continuing")
    }
  });

  //Hide fields
  $(".condlabel:not(:first)").hide();
  $(nursingLabel).hide();
  $(".condition").hide();

  $(next).hide();
  $(results).hide();

  //Declare fields incomplete and empty
  $(condfields).addClass("empty");
  $(req).addClass("incomplete");

  //Function that determines fields behavior when their values change.
  function condFieldFunction() {
    var $this = $(this);
    var value = $this.val();
    var id = $this.attr("id");
    var length = value.length;
    var parent = $this.parent();

    localStorage.setItem(id, value);

    if (length > 0 || value > 0) {
      $this.removeClass("empty");
      $this.addClass("filled");
      //If a filed is emptied change class from filled to empty.
    } else if (length < 1 || value < 1) {
      $this.removeClass("filled");
      $this.addClass("empty");
    }

    var allFilled = $this.nextAll(condfields).addBack().hasClass("filled") ? true : false;

    if (allFilled) {
      parent.addClass("complete");
      parent.removeClass("incomplete");
      parent.next(condlabels).fadeIn(500);
    } else {
      parent.addClass("incomplete");
      parent.removeClass("complete");
      parent.next(condlabels).fadeOut(500);
    }

    var reqAmt = $(".active").children(req).length;
    var compReq = $(".active").children(".complete").length;
    var remainingReq = reqAmt - compReq;

    if (remainingReq == 0) {
      $(showNext);
    } else {
      $(hideNext);
    }
  };

  //Check if required fields are already filled in order to reveal next fields
  $(condfields).each(condFieldFunction);

  $(condfields).on("change keyup blur", condFieldFunction);

  isNursing()

  //Check if Nursing/Pregnant field is empty
  // var nursingEmpty = $(nursing).prop("selectedIndex") < 1;

  // if (nursingEmpty) {
  //   isNursing();
  // }
  
  // if ($(spayNeuter).prop("selectedIndex") > 0) {
  //   isNursing();
  // }

  //Nursing field condition
  function isNursing() {

    var notSpayed = $(spayNeuter).prop("selectedIndex") > 0;
    var female = $(dogFM).prop("selectedIndex") < 1;
    var adult = $(dogAge).val() > 1;

    if (notSpayed && female && adult) {
      $(nursingLabel).fadeIn(500);
    } else {
      $(nursingLabel).fadeOut(500);
    } 
    if ($(dogFM).prop("selectedIndex") > 0) {
      $(showNext);
    }
  }

  $(dogAge).change(isNursing);
  $(dogFM).change(isNursing);
  $(spayNeuter).change(isNursing);
  $(nursing).change(isNursing);


  function identity() {
    var dogNameval = $(dogName).val();
    var dogGenderval = $(dogFM).val() == "She" ? true : false;
    $(".dogNameval").text(dogNameval);
    if (dogGenderval) {
      $(".she-he").text("she");
      $(".her-his").text("her");
      $(".her-him").text("her");
      $(".spay-neuter").text("spayed");
    } else if (!dogGenderval) {
      $(".she-he").text("he");
      $(".her-his").text("his");
      $(".her-him").text("him");
      $(".spay-neuter").text("neutered");
    }
  }


  $(dogName).change(identity);
  $(dogFM).change(identity);

  $(spayNeuter).change(function () {
    var $this = $(this);
    var optionSelect = $this.prop("selectedIndex");
    localStorage.setItem("spayNeuter", JSON.stringify(optionSelect));
    if (optionSelect > 0 && $(dogFM).prop("selectedIndex") < 1 && $(dogAge).val() > 1 &&
      $(nursing).prop("selectedIndex") < 1) {
      $this.parent().next().addClass("condlabel req incomplete");
      $this.parent().next().children(nursing).addClass("condfield empty");
      $this.parent().next().children(nursing).removeClass("filled");
      $(hideNext);
    } else {
      $this.parent().next().removeClass("condlabel req incomplete");
      $this.parent().next().children(nursing).removeClass("empty");
      $this.parent().next().children(nursing).addClass("filled");
      $(showNext);
    }
    $(isNursing);   
  }
  );

  $(nursing).change(function () {
    var $this = $(this);
    var length = $this.val().length;
    var optionSelect = $this.prop("selectedIndex");
    localStorage.setItem("nursing", JSON.stringify(optionSelect));
    if (length < 1 && $this.hasClass("condfield")) {
      $(hideNext);
    } else {
      $(showNext);
    }
    $(isNursing);   
  });

  $(dogFM).change(function () {
    var $this = $(this);
    var optionSelect = $this.prop("selectedIndex");
    localStorage.setItem("dogFM", JSON.stringify(optionSelect));
    $(isNursing);    
  });

  $(date).change(function () {
    var $this = $(this);
    var optionSelect = $this.prop("selectedIndex");
    localStorage.setItem("date", JSON.stringify(optionSelect));
    $(isNursing);   
  });

  $(dogHealth).change(function () {
    var $this = $(this);
    var optionSelect = $this.prop("selectedIndex");
    localStorage.setItem("dogHealth", JSON.stringify(optionSelect));
  });

  function saveDog() {

    //Save last dog before showing results
    var value = {
      name: `${$(dogName).val()}`,
      age: `${$(dogAge).val()}`,
      date: `${$(date).prop("selectedIndex") != 0 ? true : false}`,
      nursing: `${$(nursing).prop("selectedIndex") == 2 ? true : false}`,
      weight: `${$(dogWeight).val()}`,
      health: `${$(dogHealth).prop("selectedIndex") != 0 ? true : false}`
    };
    
    dogCount = localStorage.getItem("dogCount");
    dogCount++;
    localStorage.setItem("dogCount", JSON.stringify(dogCount));
    localStorage.setItem("dog" + `${dogCount}`, JSON.stringify(value));
  }

  //On reset form function
  $(reset).click(function () {
    if (animating) { } else {
      animating = true;
      localStorage.clear();
      window.location.reload();
      animating = false;
    }
  });

  //On add dog form function
  $(add).click(function () {

    saveDog();

    //Reset Fields without deleting dogs
    localStorage.removeItem("dogName");
    localStorage.removeItem("dogAge");
    localStorage.removeItem("dogWeight"); 
    localStorage.removeItem("date"); 
    localStorage.removeItem("dogFM"); 
    localStorage.removeItem("spayNeuter"); 
    localStorage.removeItem("nursing"); 
    localStorage.removeItem("dogHealth");

    window.location.reload();
  });

  function oneLbFiller() {
    var amt = $.parseJSON(localStorage.getItem("finalAmt"));
    //How much of the infographic container to fill up with color
    if (amt <= 5.9) {
      ctrB.attr("style", "fill:red");
    } else if (amt <= 9.9) {
      ctrB.attr("style", "fill:red");
      ctrLM.attr("style", "fill:red");
    } else if (amt <= 13.9) {
      ctrB.attr("style", "fill:red");
      ctrLM.attr("style", "fill:red");
      ctrHM.attr("style", "fill:red");
    } else if (14 <= amt <= 16) {
      ctrB.attr("style", "fill:red");
      ctrLM.attr("style", "fill:red");
      ctrHM.attr("style", "fill:red");
      ctrT.attr("style", "fill:red");
    }
    //Reveal Infographic
    $("#cup-infographic2").fadeOut(50);
    $("#cup-infographic").fadeIn(500);
  };

  function threeLbsFiller() {
    finalAmt = $.parseJSON(localStorage.getItem("finalAmt"));
    //How much of the infographic container to fill up with color
    if (finalAmt <= 16) {
      btrB.attr("style", "fill:red");
    } else if (finalAmt <= 24) {
      btrB.attr("style", "fill:red");
      btrLM.attr("style", "fill:red");
    } else if (finalAmt <= 36) {
      btrB.attr("style", "fill:red");
      btrLM.attr("style", "fill:red");
      btrHM.attr("style", "fill:red");
    } else if (finalAmt <= 48) {
      btrB.attr("style", "fill:red");
      btrLM.attr("style", "fill:red");
      btrHM.attr("style", "fill:red");
      btrT.attr("style", "fill:red");
    }
    //Reveal Infographic
    $("#cup-infographic").fadeOut(50);
    $("#cup-infographic2").fadeIn(500);
  };

  //On submit form function
  $(submit).click(function () {

    saveDog();

    //Simplify age and weight variables
    var [age, weight] = [$(dogAge).val(), $(dogWeight).val()];

    //Declare adult dog calculation equation
    var adultAmt = (weight / 10) * 4;

    //Check if dog has condition or diet
    var dogCondition;
    if ($(dogHealth).val() == "true") {
      dogCondition = true
    } else {
      dogCondition = false
    }

    //If dog has a condition or diet, reveal disclaimer
    if (dogCondition) {
      $(".condition").fadeIn(500);
    } else {
      $(".condition").fadeOut(500);
    }

    //If dog is 1yo or less or dog is pregnant, show Puppy or Nursing result
    if (age <= 1 || $("#date").val() != "years" || $(nursing).val() == "is") {
      $("#pupOz").text(weight);
      $("#pupLb").text(weight / 16);
      
      $("#pupNursing").fadeIn(500);
      $("#pupReset").fadeIn(500);
      $("#adults").fadeOut(500);
      finalAmt = weight;
      localStorage.setItem("finalAmt", JSON.stringify(finalAmt));
    } else {

      //If dog is more than 1yo and is not pregnant, show Adult result
      $("#adultOz").text((adultAmt));
      $("#adultLb").text((adultAmt / 16));
      
      $("#adults").fadeIn(500);
      $("#adultReset").fadeIn(500);
      $("#pupNursing").fadeOut(500);
      finalAmt = adultAmt;
      localStorage.setItem("finalAmt", JSON.stringify(finalAmt));
    }

    //Food Container filler
    if (finalAmt <= 16) {
      oneLbFiller();
    } else if (finalAmt > 16) {
      threeLbsFiller();
    }

    //Add dogs to results navbar
    dogCount = $.parseJSON(localStorage.getItem("dogCount"));
    if (dogCount > 1) {
      for (let i = 1; i <= dogCount; i++) {
        var pDog =  $.parseJSON(localStorage.getItem(`${"dog"+i}`));
        var doghtml = `${'<input id="dog'  + i + '"' + ' type="button" name="dogselect" class="dogselect" value="'+ pDog.name + '">'}`;
        $("#dognav").append(doghtml);
      }
    }
    
    //Reveal Collections for easy add to cart
    $("#collection-section").fadeIn(500);
  });


  $(document).on("click", dogSelect, function () {
    var $this = $(this);
    var id = $this.attr("id");
    var dogValues = $.parseJSON(localStorage.getItem(`${id}`));
    var dogNameSpan = $(".dogNameval");
    var [pName, pAge, pDate, pNursing, pWeight, pHealth] = 
    [dogValues.name, dogValues.age, dogValues.date, dogValues.nursing, 
      dogValues.weight, dogValues.health];

    //Update Dog Result
    $(dogNameSpan).text(pName);
    if (pAge <= 1 || $.parseJSON(pDate) || $.parseJSON(pNursing)) {
      //Declare pup/nursing calculation equation
      $("#pupOz").text(pWeight);
      $("#pupLb").text(pWeight / 16);
      $("#pupNursing").fadeIn(500);
      $("#pupReset").fadeIn(500);
      $("#adults").fadeOut(500);
      $("#adultReset").fadeOut(500);
      finalAmt = pWeight;
      localStorage.setItem("finalAmt", JSON.stringify(finalAmt));
    } else {
      //Declare adult dog calculation equation
      var adultAmt = (pWeight / 10) * 4;
      $("#adultOz").text((adultAmt));
      $("#adultLb").text((adultAmt / 16));
      $("#adults").fadeIn(500);
      $("#adultReset").fadeIn(500);
      $("#pupNursing").fadeOut(500);
      $("#pupReset").fadeOut(500);
      finalAmt = adultAmt;
      localStorage.setItem("finalAmt", JSON.stringify(finalAmt));
    }

    //If dog has condition show disclaimer
    if ($.parseJSON(pHealth)) {
      $(".condition").fadeIn(500);
    } else {
      $(".condition").fadeOut(500);
    }
    
    //Food Container filler
    if (finalAmt <= 16) {
      oneLbFiller();
    } else if (finalAmt > 16) {
      threeLbsFiller();
    }

  })
});